import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SessionFun from './functions/sessionFun';
import Alert from './Alert';
import { getUserInfo } from './functions/userInfo';
import * as atlas from 'azure-maps-control';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import close from '../Asset/close.svg';
import { Modal, Form } from 'react-bootstrap';
import TimePicker from 'rc-time-picker';
import * as moment from 'moment';
import './css/popupStyle.css';
import { Spinner } from "react-bootstrap";
import { environment } from './functions/environment';
import { set } from 'firebase/database';

var cordListg = [];
var map, dataSource, layersList = [], popup;
var simplePopupTemplate = '<div class="customInfobox"><p class="name">{name}</p><p class="pop-text">{description}</p></div>';
// var simplePopupTemplate = '<div class="customInfobox"><div class="name">{name}</div>{description} <p>{count}</p></div>';

function Location_Tracking() {
    let userObj = getUserInfo();
    var date = new Date();
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0');
    var yyyy = date.getFullYear();
    const [today, setToday] = useState(yyyy + "-" + mm + "-" + dd);

    let [alert, setAlert] = useState({
        msg: "",
        status: false
    });
    let [sessOut, setSessOut] = useState(false);
    let [siteList, setSiteList] = useState([]);
    let [allAseet, setAllAsset] = useState([]);
    let [filterError, setFilterError] = useState({});
    let [lastDate, setLastDate] = useState("");
    let [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        layersList = []
        getLocation();
        getSiteList();
    }, []);
    let [filter, setFilter] = useState({
        equipmentID: "",
        siteID: "",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: ""
    });
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
        setFilter({
            equipmentID: "",
            siteID: "",
            startDate: "",
            endDate: "",
            startTime: "",
            endTime: ""
        });
    }

    const handleShow = () => {
        setShow(true);
    }

    function clearFilter() {
        setFilter({
            equipmentID: "",
            siteID: "",
            startDate: "",
            endDate: "",
            startTime: "",
            endTime: ""
        });
        getTrackingLocation({
            equipmentID: "",
            siteID: "",
            startDate: "",
            endDate: ""
        });
        setFilterError({});
    }
    function getSiteList() {
        fetch(environment.baseUrl + "getSiteByUserAccount", {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                if (resp.code == 200) {
                    setSiteList(resp.data.result.siteList);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setSiteList([]);
                }
            })
        })
    }
    function getEquipmentBySite(sid) {
        fetch(environment.baseUrl + "getEquipmentBySite?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(
                {
                    siteID: sid
                })
        }).then((result) => {
            result.json().then(res => {
                if (res.code == 200) {
                    setAllAsset(res.data.result);
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    setAllAsset([]);
                }
            })
        })
    }
    function calMaxEndDate(std) {
        var new_date = moment(std).add(30, 'days');
        var date8w = moment(new_date).format('YYYY-MM-DD');
        let calDate = new Date(date8w);
        let todate = new Date(today);
        if (calDate < todate) {
            setLastDate(date8w);
        }
        else {
            setLastDate(today);
        }
    }
    function getFilterData(e) {
        if (e.target.name === "siteID") {
            setFilter({ ...filter, [e.target.name]: parseInt(e.target.value) });
            getEquipmentBySite(e.target.value);
        }
        else {
            setFilter({ ...filter, [e.target.name]: e.target.value });
        }

        if (e.target.name === "startDate") {
            calMaxEndDate(e.target.value);
        }
    }

    function getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                let log = position.coords.longitude;
                let lat = position.coords.latitude;
                let cord = [];
                cord.push(log, lat);
                InitMap(cord);
            });
        } else {
            setAlert({
                msg: "Geolocation is not supported by this browser.",
                status: true
            })
        }
    }
    function validateFilter() {
        let error = {};
        if (filter.startDate == "" && filter.endDate != "") {
            error.startDate = "for date range this field is required";
        }
        if (filter.startDate != "" && filter.endDate == "") {
            error.endDate = "for date range this field is required";
        }
        if (filter.startTime == "" && filter.endTime != "") {
            error.startTime = "for time range this field is required";
        }
        if (filter.startTime != "" && filter.endTime == "") {
            error.endTime = "for time range this field is required";
        }
        if (filter.startDate != "" && filter.endDate != "" && filter.siteID == "") {
            error.siteID = "with date range this field required"
        }
        if (filter.startDate != "" && filter.endDate != "" && filter.equipmentID == "") {
            error.equipmentID = "with date range this field required"
        }
        setFilterError(error);
        if (Object.keys(error).length == 0) {
            setIsLoading(true);
            let req = {};
            if (filter.startDate != "") {
                if (filter.startTime != "") {
                    getTrackingLocation({
                        equipmentID: filter.equipmentID,
                        siteID: filter.siteID,
                        startDate: filter.startDate + " " + filter.startTime,
                        endDate: filter.endDate + " " + filter.endTime
                    });
                }
                else {
                    getTrackingLocation({
                        equipmentID: filter.equipmentID,
                        siteID: filter.siteID,
                        startDate: filter.startDate + " 00:00:00",
                        endDate: filter.endDate + " 23:59:59"
                    });
                }
            }
            else {
                getTrackingLocation({
                    equipmentID: filter.equipmentID,
                    siteID: filter.siteID,
                    startDate: filter.startDate,
                    endDate: filter.endDate
                });
            }
        }
    }
    function getTrackingLocation(req) {
        fetch(environment.baseUrl + "locationTracking", {
            method: "Post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(req)
        }).then((result) => {

            result.json().then((res) => {
                var list = [];
                if (res.code == 200) {
                    clearAllLayears();
                    // setShow(false);
                    if (req.startDate != "" && req.endDate != "") {
                        for (let index = 0; index < res.data.length; index++) {
                            const element = res.data[index];
                            list.push([element.Long, element.Lat]);
                            if (index == (res.data.length) - 1) {
                                markRoute(list);
                            }
                        }//for mark line
                    }
                    else {
                        // let fobj = groupByLoc(res.data);// for showing multiple asset details have same lat long.
                        let allowSet = true;
                        var temp = [
                            { Long: 72.832267, Lat: 18.925321, assetID: "SIMA14" },
                            { Long: 73.733706, Lat: 18.58599, assetID: "SIMA13" },
                            { Long: 73.733706, Lat: 18.58599, assetID: "SIMA12" },
                            { Long: 73.733706, Lat: 18.58599, assetID: "SIMA12" },
                        ]
                        let arr = [];
                        res.data.forEach((element, i) => {
                            if (allowSet) {
                                setCamera([element.Long, element.Lat]);
                                allowSet = false;
                            }
                            arr.push({ loc: [element.Long, element.Lat], id: element.assetID, date: element.IST })
                        });
                        MarkerPopup(arr);
                    }

                    if (res.data.length == 0) {
                        setAlert({
                            msg: res.msg,
                            status: true,
                        })
                    }
                }
                else if (res.code == 401) {
                    setSessOut(true);
                }
                else {
                    console.log("api fail")
                }
            })

        });
    }
    function InitMap(cord) {
        var compo = document.getElementById("mapDiv");

        map = new atlas.Map(compo, {
            center: cord,//[72.877426, 19.076090],
            zoom: 16,
            language: 'en-US',
            renderWorldCopies: false,
            // view: "Auto",
            authOptions: {
                authType: 'subscriptionKey',
                subscriptionKey: 'du-131aV_juHMnKzXuYjulfzzZdKfRCI2vIDu3V01VU'
            },
            showLogo: false,
            showFeedbackLink: false
        });

        map.events.add('ready', function () {
            dataSource = new atlas.source.DataSource();
            map.sources.add(dataSource);

            getTrackingLocation({
                equipmentID: "",
                siteID: "",
                startDate: "",
                endDate: ""
            });

            //Create a popup but leave it closed so we can update it and display it later.
            popup = new atlas.Popup({
                position: [0, 0],
                pixelOffset: [0, -18]
            });
        });
    }
    function markRoute(cordList) {
        if (popup.isOpen()) {
            popup.close();
        }
        var cord = getCenterPoint(cordList);
        map.imageSprite.add('arrow-icon', 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/1717245/purpleArrowRight.png').then(function () {
            //Create a line and add it to the data source.
            dataSource.add(new atlas.data.Feature(new atlas.data.LineString(cordList)));
            map.layers.add([
                //Add a line layer for displaying the line.
                new atlas.layer.LineLayer(dataSource, null, {
                    strokeColor: 'DarkOrchid',
                    strokeWidth: 3
                }),

                //Add a symbol layer for rendering the arrow along the line.
                new atlas.layer.SymbolLayer(dataSource, null, {
                    //Specify how much space should be between the symbols in pixels.
                    lineSpacing: 100,

                    //Tell the symbol layer that the symbols are being rendered along a line.
                    placement: 'line',
                    iconOptions: {
                        image: 'arrow-icon',
                        allowOverlap: true,
                        anchor: 'center',
                        size: 0.8
                    }
                })
            ]);
        });
        setCamera(cord);
        if (cordList.length > 2) {
            let start = cordList[0];
            let end = cordList[cordList.length - 1];
            var pointArr = [];
            pointArr.push(new atlas.data.Feature(new atlas.data.Point(start)));
            pointArr.push(new atlas.data.Feature(new atlas.data.Point(end)));

            dataSource.add(pointArr);
            var layer = new atlas.layer.SymbolLayer(dataSource);
            layersList.push(layer);
            map.layers.add(layer);
        }
        setShow(false);
        setIsLoading(false);
    }
    function addMarkers(cord, text, img) {
        var point = new atlas.data.Point(cord);
        dataSource.add(point);
        var layer = new atlas.layer.SymbolLayer(dataSource);
        layersList.push(layer);
        map.layers.add(layer);
    }
    function MarkerPopup(obj) {
        var pointArr = [];
        obj.forEach(element => {
            pointArr.push(new atlas.data.Feature(new atlas.data.Point(element.loc), {
                name: element.id,
                description: element.date
            }));
        });
        dataSource.add(pointArr);
        var layer = new atlas.layer.SymbolLayer(dataSource);
        layersList.push(layer);
        map.layers.add(layer);
        //Add a click event to the symbol layer.
        map.events.add('click', layer, symbolClicked);
        setShow(false);
        setIsLoading(false);
    }
    function symbolClicked(e) {
        //Make sure the event occurred on a point feature.
        if (e.shapes && e.shapes.length > 0) {
            var content, coordinate;

            //Check to see if the first value in the shapes array is a Point Shape.
            if (e.shapes[0] instanceof atlas.Shape && e.shapes[0].getType() === 'Point') {
                var properties = e.shapes[0].getProperties();
                content = simplePopupTemplate.replace(/{name}/g, (properties.name).replaceAll(",", ", ")).replace(/{description}/g, (properties.description).replaceAll(",", "<br/>"));
                // content = simplePopupTemplate.replace(/{name}/g, properties.name).replace(/{description}/g, properties.description).replace(/{count}/g, 1);
                coordinate = e.shapes[0].getCoordinates();
            } else if (e.shapes[0].type === 'Feature' && e.shapes[0].geometry.type === 'Point') {

                //Check to see if the feature is a cluster.
                if (e.shapes[0].properties.cluster) {
                    content = '<div style="padding:10px;">Cluster of ' + e.shapes[0].properties.point_count + ' symbols</div>';
                } else {
                    //Feature is likely from a VectorTileSource.
                    content = simplePopupTemplate.replace(/{name}/g, properties.name).replace(/{description}/g, properties.description);
                }

                coordinate = e.shapes[0].geometry.coordinates;
            }

            if (content && coordinate) {
                //Populate the popupTemplate with data from the clicked point feature.
                popup.setOptions({
                    //Update the content of the popup.
                    content: content,

                    //Update the position of the popup with the symbols coordinate.
                    position: coordinate
                });

                //Open the popup.
                popup.open(map);
            }
        }
    }
    function clearAllLayears() {
        dataSource.clear();
        if (layersList.length > 0) {
            map.layers.remove(layersList);
        }
        layersList = [];
    }
    function getCenterPoint(array) {
        let x = 0, y = 0, z = 0;
        array.forEach(element => {
            let log = element[0] * Math.PI / 180;
            let lat = element[1] * Math.PI / 180;
            x += Math.cos(lat) * Math.cos(log);
            y += Math.cos(lat) * Math.sin(log);
            z += Math.sin(lat);
        });

        let total = array.length;
        x = x / total;
        y = y / total;
        z = z / total;

        let clog = Math.atan2(y, x);
        let csqr = Math.sqrt(x * x + y * y);
        let clat = Math.atan2(z, csqr);

        let rlog = clog * 180 / Math.PI;
        let rlat = clat * 180 / Math.PI;

        return [rlog, rlat]
    }
    function setCamera(cord) {
        map.setCamera({
            center: cord,
            zoom: 16,
            duration: 3000,
            type: 'fly'
        });
    }
    let [timer, setTimer] = useState({
        startTime: null,
        endTime: null
    })
    const format = 'h:mm a';
    function addFilterTimeChange(value, fname) {
        if (value) {
            setFilter({ ...filter, [fname]: value.format().slice(11, 16) });
            let temp = value.format().slice(0, 17);
            let h = parseInt(temp.slice(11, 13));
            let m = parseInt(temp.slice(14, 16));
            setTimer({ ...timer, [fname]: moment().hour(h).minute(m) });
        }
        else {
            setFilter({ ...filter, [fname]: "" });
            setTimer({ ...timer, [fname]: null });
        }
    }
    function groupByLoc(raw) {
        let arr;
        const organizedArrays = {};
        raw.forEach(item => {
            const key = `${item.Lat}-${item.Long}`;
            if (!organizedArrays[key]) {
                organizedArrays[key] = [];
            }
            organizedArrays[key].push(item);
        });
        const result = Object.values(organizedArrays);
        arr = arrageObj(result);
        return arr;
    }
    function arrageObj(data) {
        let result = [];
        data.forEach(array => {
            let obj = {}, id = [], date = [], did = [];
            array.forEach(element => {
                obj = element;
                id.push(element.assetID);
                date.push(element.IST);
                did.push(element.DevId);

            });
            if (id.length) {
                obj.assetID = id.toString();
                obj.IST = date.toString();
                obj.DevId = did.toString();
                result.push(obj);
            }

        });
        return result
    }
    return (
        <div className='main-container'>
            <SessionFun show={sessOut}></SessionFun>
            <Alert obj={alert} />
            <h4 className='main-heading'>Location Tracking</h4>
            <p className='short-link'><Link to='/'>Home&nbsp;
                <i className='fa fa-angle-right'></i></Link>&nbsp;Location Tracking
            </p>

            <div className="card-box-block mt-3" style={{ width: "100%" }}>
                <div className="w-100">
                    <div className="row mb-3">
                        <div className="col-sm-10 left-col">
                            <h6 className='cardtitle pb-0'>Location Tracking</h6>
                            <small className='red'>Only last known location is display if date range is not selected</small>
                        </div>
                        <div className="col-sm-2  text-end">
                            <FontAwesomeIcon icon={faBars} onClick={() => handleShow()} />
                        </div>
                    </div>
                </div>

                <div id="mapDiv" className="row mb-3 px-2" style={{ height: '400px' }}></div>
            </div>


            <Modal show={show} onHide={handleClose} centered backdrop="static" size="lg">
                <Modal.Header>
                    <Modal.Title> Filters</Modal.Title>
                    <button onClick={handleClose} disabled={isLoading} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className=' logout-box'>
                    <div className='row'>
                        <div className='col-sm-4 '>
                            <Form.Group className="mb-2" >
                                <label>Site</label>
                                <Form.Select as='select' name='siteID' className="textbox-back" value={filter.siteID} onChange={getFilterData}>
                                    <option value="">Select Site</option>
                                    {
                                        siteList.map((item, index) =>
                                            <option key={index} value={item.siteID}>{item.siteName}</option>
                                        )
                                    }
                                </Form.Select>
                                <small className='red'>{filterError.siteID}</small>
                            </Form.Group>
                        </div>
                        <div className='col-sm-4'>
                            <Form.Group className="mb-2" >
                                <label>Equipment ID</label>
                                <Form.Select as='select' name='equipmentID' className="textbox-back" value={filter.equipmentID} onChange={getFilterData}>
                                    <option value="">Select Equipment ID</option>
                                    {
                                        allAseet.map((item, index) =>
                                            <option key={index} value={item.assetID}>{item.assetID}</option>
                                        )
                                    }
                                </Form.Select>
                                <small className='red'>{filterError.equipmentID}</small>
                            </Form.Group>
                        </div>
                        <div className='col-sm-4'>
                            <Form.Group className="mb-2" >
                                <label>From Date</label>
                                <Form.Control type='date' placeholder='startDate' name='startDate' value={filter.startDate}
                                    className="textbox-back" onChange={getFilterData} max={today} />
                                <small className='red'>{filterError.startDate}</small>
                            </Form.Group>
                        </div>

                        <div className='col-sm-4'>
                            <Form.Group className="mb-2" >
                                <label>To Date</label>
                                <Form.Control type='date' placeholder='endDate' name='endDate' value={filter.endDate} min={filter.startDate}
                                    className="textbox-back" onChange={getFilterData} max={filter.startDate == "" ? today : lastDate} />
                                <small className='red'>{filterError.endDate}</small>
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-2" >
                                <label>Start Time</label>
                                <TimePicker
                                    value={timer.startTime}
                                    showSecond={false}
                                    className="form-control textbox-back"
                                    onChange={(e) => addFilterTimeChange(e, "startTime")}
                                    format={format}
                                    minuteStep={5}
                                    use12Hours
                                    inputReadOnly
                                    placeholder="Start Time"
                                />
                                <small className='red'>{filterError.startTime}</small>
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-2" >
                                <label>End Time</label>
                                <TimePicker
                                    value={filter.endTime == "" ? null : timer.endTime}
                                    showSecond={false}
                                    className="form-control textbox-back"
                                    onChange={(e) => addFilterTimeChange(e, "endTime")}
                                    format={format}
                                    minuteStep={5}
                                    use12Hours
                                    inputReadOnly
                                    placeholder="End Time"
                                />
                                <small className='red'>{filterError.endTime}</small>
                            </Form.Group>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <small className='red'><b>Maximum 30 days are allowed to select</b></small>
                        </div>
                        <div className="col-sm-12">
                            {
                                isLoading ?
                                    <p className='text-center mb-0'><Spinner size="sm" animation="border" variant="primary" /> Please wait loading data...</p>
                                    : null
                            }
                        </div>
                    </div>

                    <div className="row text-center mt-4">
                        <div className="col-sm-6">
                            <button className="btn btn-outline-secondary lo-btn float-end" onClick={clearFilter}>
                                Reset
                            </button>
                        </div>
                        <div className="col-sm-6">
                            <button className="add-btn btn-light lo-btn confirm-btn float-start" onClick={validateFilter} disabled={isLoading}>
                                Apply
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>




    )
}

export default Location_Tracking
